import { useMemo } from 'react';

import { LengthIndicator } from '@da-g3-acl/shared/common';

import { LengthRange } from '../types/lengthRange';

export { useCalculateAnchorPositions };

export interface LengthIndicatorWithYPosition {
	lengthM: number;
	lengthIndicators: LengthIndicator[];
}

interface UseCalculateAnchorPositionsProps {
	lengthIndicators: LengthIndicator[] | undefined;
	visibleRange: LengthRange;
}

const useCalculateAnchorPositions = ({
	lengthIndicators,
	visibleRange,
}: UseCalculateAnchorPositionsProps): LengthIndicatorWithYPosition[] => {
	const anchorPostions = useMemo(() => {
		const result: LengthIndicatorWithYPosition[] = [];

		let lastLengthM: number | null = null;
		let currentGroup: LengthIndicator[] = [];

		const lengthIndicatorsSorted = (lengthIndicators ?? []).sort((a, b) => a.atLength - b.atLength);
		for (let i = 0; i < lengthIndicatorsSorted.length; i++) {
			const lengthIndicator = lengthIndicatorsSorted[i];
			const isVisible =
				visibleRange.depthFrom <= lengthIndicator.atLength && visibleRange.depthTo >= lengthIndicator.atLength;

			const currentLengthM = lengthIndicator.atLength;

			if (lastLengthM !== null && (currentLengthM !== lastLengthM || i === lengthIndicatorsSorted.length - 1)) {
				if (currentGroup.length > 0) result.push({ lengthM: lastLengthM, lengthIndicators: currentGroup });
				currentGroup = [];
			}

			if (isVisible) currentGroup.push(lengthIndicator);

			lastLengthM = currentLengthM ?? null;
		}

		return result;
	}, [lengthIndicators, visibleRange.depthFrom, visibleRange.depthTo]);

	return anchorPostions;
};
